export default {
    state: {
        isLoading: false,
    },
    mutations: {
        startLoading(state, timeout) {
            state.isLoading = true;

            var store = this;
            setTimeout(function () {
                store.commit('stopLoading');
            }, timeout || 300000);
        },
        stopLoading(state) {
            state.isLoading = false;
        },
    },
};
